<mat-dialog-content>
  <pre>
{{data | json }}
</pre>
</mat-dialog-content>

